import qs from 'qs';

import browserHistory from 'utils/browserHistory';
import { getCurrentTab } from 'utils/tabsHelper';

//@todo: refactor this function.
export const getBrowserHistory = (
  newSearchObj,
  locationSearch,
  locationHash
) => {
  const hash = locationSearch.split('#')[1] || '';
  let tabHash = locationHash ? locationHash : '#' + hash;
  tabHash = tabHash !== '#' ? tabHash : '';
  const currentSearchObj = locationSearch
    ? qs.parse(locationSearch.split('#')[0], {
        ignoreQueryPrefix: true,
      })
    : {};

  return '?' + qs.stringify({ ...currentSearchObj, ...newSearchObj }) + tabHash;
};

export const setBrowserHistory = (newSearchObj, locationSearch, hash) => {
  browserHistory.push({
    search: getBrowserHistory(newSearchObj, locationSearch, hash),
  });
};

export const clearSearchHistory = (locationSearch) => {
  const tabHash = getCurrentTab().length ? '#' + getCurrentTab() : '';
  const { country } = qs.parse(locationSearch.split('#')[0], {
    ignoreQueryPrefix: true,
  });

  browserHistory.push({
    search: '?' + qs.stringify({ country }) + tabHash,
  });
};



// WEBPACK FOOTER //
// ./src/utils/historyPushSearch.js